import {useSessionStore} from "@/utils/useSessionStore.js";

export function currency(val, locale) {
  let digits = 0;
  const sessionStore = useSessionStore();
  if(locale === undefined) {
    locale = sessionStore.getCurrency || 'krw';
  }

  if(locale !== 'krw') {
    digits = 2;
  }

  let num = new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(val);

  return num + ((locale === 'krw') ? ' 원' : ' (USD)');
}

export function numberFormat(val, digits=0) {
  return new Intl.NumberFormat('ko-KR', {
    style: 'decimal',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(val);
}
